import { render, staticRenderFns } from "./ItemsCondition.vue?vue&type=template&id=08d87016&scoped=true"
import script from "./ItemsCondition.vue?vue&type=script&lang=js"
export * from "./ItemsCondition.vue?vue&type=script&lang=js"
import style0 from "./ItemsCondition.vue?vue&type=style&index=0&id=08d87016&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d87016",
  null
  
)

export default component.exports